window.MVSTABT = window.MVSTABT || {};

window.MVSTABT.timestamp = function () {
    let dt = new Date();
    return dt.getFullYear() + "-" +(dt.getMonth()+1) + "-" + dt.getDate() + "T" +dt.getHours()+":"+dt.getMinutes()+":"+dt.getSeconds()+"."+dt.getMilliseconds();
};

window.MVSTABT.debug = function (msg) {
    if (location.href.indexOf("mdebug=1") > -1 || document.cookie.indexOf("mdebug=1") > -1) {
        console.log(`[${window.MVSTABT.timestamp()}] mvst-abt: ${msg}`);
    }
};

window.MVSTABT.delay = async function (ms){
    return new Promise(resolve => setTimeout(resolve, ms));
};

window.MVSTABT.waitFor = async function (fn, interval, timeout) {
    interval = interval || 500;
    timeout = timeout || 30*1000;

    return new Promise((resolve, reject) => {
        let intervalObj = setInterval(() => {
            if (fn()) {
                clearInterval(intervalObj);
                clearTimeout(timeoutObj);
                resolve("");
            }
        }, interval);

        let timeoutObj = setTimeout(() => {
            clearInterval(intervalObj);

            if (fn()) {
                resolve("");
            } else {
                reject("Wait failed");
            }
        }, timeout);
    });
};

window.MVSTABT.setCookie = function (name, value, expireDays) {
    let expires = new Date(Date.now() + expireDays * 24 * 60 * 60 * 1e3).toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/`;
};

window.MVSTABT.getCookie = function (name) {
    let cookieArray = document.cookie.split("; ");
    for (let cookie of cookieArray) {
        let [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
            return cookieValue;
        }
    }
    return "";
};

window.MVSTABT.writeToLocalStorage = function (key, value) {
    localStorage.setItem(key, value);
};

window.MVSTABT.readFromLocalStorage = function (key) {
    const value = localStorage.getItem(key);
    return value ? value : null;
};

window.MVSTABT.setTestId = function (testId) {
    // write "mvst-abt-id" to cookie
    window.MVSTABT.setCookie("mvst-abt-id", testId, 365);
    window.MVSTABT.writeToLocalStorage("mvst-abt-id", testId);
};

window.MVSTABT.getTestId = function () {
    // read "mvst-abt-id" from cookie; if not found, then get from localstorage
    let testId = window.MVSTABT.getCookie("mvst-abt-id");
    if (!testId) {
        testId = window.MVSTABT.readFromLocalStorage("mvst-abt-id");
    }

    return testId;
};

window.MVSTABT.urlParam = function (url, name) {
    let results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url);
    if (!results || !results[1]) {
        return "";
    }
    return decodeURIComponent(results[1]);
};

/**
 * priority: valid urlTestId > valid localTestId > exp0
 */
window.MVSTABT.matchExperiencesByTestId = function (urlTestId, localTestId, experiences) {
    let debug = window.MVSTABT.debug;

    // stringify to compare
    urlTestId = urlTestId + "";
    localTestId = localTestId + "";
    debug(`urlTestId[${urlTestId}] and localTestId[${localTestId}]`);

    let testId = null;

    if (experiences.find(exp => exp.id === localTestId)) {
        testId = localTestId;
        debug(`localTestId[${localTestId}] found in experiences, so honor it`);
    } else if (experiences.find(exp => exp.id === urlTestId)) {
        testId = urlTestId;
        debug(`no valid localTestId[${localTestId}]. But urlTestId[${urlTestId}] found in experiences, so honor it`);
    }

    if (!testId) {
        debug(`no testId detected, so use default experience`);
        return [experiences[0], experiences[1]];
    }

    let exp1, exp2 = null;

    for (let i = 0; i < experiences.length; i++) {
        if (experiences[i].id === testId) {
            exp1 = experiences[i];
            exp2 = experiences[(i+1) % 2];
            break;
        }
    }

    if (!exp1) {
        debug(`testId[${testId}] not found in experiences`);
        return [experiences[0], experiences[1]];
    }

    return [exp1, exp2];
};

window.MVSTABT.setCss = function (css) {
    const debug = window.MVSTABT.debug;
    let existStyleEle = document.querySelector("#mvst-abt-style");
    if (existStyleEle) {
        existStyleEle.innerHTML = css;
        debug(`Updated css[${css}]`);
    } else {
        let style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        style.id = "mvst-abt-style";
        document.head.appendChild(style);
        debug(`Appended css[${css}]`);
    }
};

window.MVSTABT.applyExperiences = function (exp1, exp2) {
    const debug = window.MVSTABT.debug;

    // Setup CSS
    let css = `
        *[mvst-abt='${exp2.id}'] {display: none;!important}
        product-list > div:has(> *[mvst-abt='${exp2.id}']) {display: none;!important}
    `;
    window.MVSTABT.setCss(css);
    debug(`Applied css[${css}]`);

    // Redirect to the other experience  if test id not match in the product detail page
    let handle = location.pathname.split("/").pop();

    if (!exp1.handles.includes(handle) && !exp2.handles.includes(handle)) {
        debug(`The current product[${handle}] is not in any experience, something wrong`);
        return;
    }

    if (exp2.handles.includes(handle)) {
        let url = location.href.replace(handle, exp1.handles[exp2.handles.indexOf(handle)]);
        debug(`The current product[${handle}] is in exp2, so redirect to exp1 and the new page is [${url}]`);
        location.href = url;
    }
};

(async function() {
    let debug = window.MVSTABT.debug;
    let applyExperiences = window.MVSTABT.applyExperiences;
    let matchExperiencesByTestId = window.MVSTABT.matchExperiencesByTestId;
    let urlParam = window.MVSTABT.urlParam;
    let setTestId = window.MVSTABT.setTestId;

    async function start(experiences) {
        // Get url parameter value of "mt=" from the current page url;
        let urlTestId = urlParam(location.href, "mt");
        let localTestId = window.MVSTABT.getTestId();
        let [exp1, exp2] = matchExperiencesByTestId(urlTestId, localTestId, experiences);
        debug(`exp1[${exp1.id}] and exp2[${exp2.id}]`);

        if (exp1.id === urlTestId && urlTestId !== localTestId) {
            setTestId(urlTestId);
            debug(`urlTestId[${urlTestId}] is selected in exp1 and is different from localTestId[${localTestId}], so save it in local`);
        }

        applyExperiences(exp1, exp2);
    }

    /**
     * It should always be 2 experiences
     */
    const EXPERIENCES = [
        {
            id: "202404251200",
            handles: [
                "trek-aluminum-suitcase-army-green",
                "trek-aluminum-suitcase-black",
                "trek-aluminum-suitcase-champagne",
                "trek-aluminum-suitcase-gunmetal",
                "trek-aluminum-suitcase-red",
                "trek-aluminum-suitcase-silver"
            ]
        },{
            id: "202404251201",
            handles: [
                "trek-aluminum-army-green",
                "trek-aluminum-black",
                "trek-aluminum-champagne",
                "trek-aluminum-gunmetal",
                "trek-aluminum-red",
                "trek-aluminum-silver"
            ]
        }
    ];

    debug("mvst-abt.js loaded");
    await start(EXPERIENCES);
})();